import * as z from 'zod';
import { CursorDirections, SortDirections } from '../util/apply-cursor.js';
export const CursorDirection = z.enum([CursorDirections.backward, CursorDirections.forward]);
export const Cursor = z.object({
    // extend this type and enumerate here all fields specified in `sort.field`!
    id: z.string(),
    direction: CursorDirection.default(CursorDirections.forward),
});
export const SortDirection = z.enum([SortDirections.asc, SortDirections.desc]);
export const Sort = z.object({
    dir: SortDirection.default(SortDirections.desc),
});
//# sourceMappingURL=util.js.map